import { useDialogControls } from "./useDialogControls";

export const useContactDialogControls = () =>
  useDialogControls("contactDialog");
